import React from "react";
import { ExpandMore } from "@mui/icons-material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../i18n/LocalizedText.js";
const useStyles = makeStyles()((theme) => ({
  tableContainer: {
    boxShadow: "none"
  },
  tableCellBottom: {
    border: "none"
  },
  accordionDetails: {
    padding: 0
  },
  accordionHeader: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1)
  }
}));
const StyledAccordion = ({
  header,
  componentId,
  children,
  unmountOnCollapse,
  className,
  isCollapsed = false
}) => {
  const { classes } = useStyles();
  const [expanded, setExpanded] = React.useState(!isCollapsed);
  const handleExpand = (_event, expanded2) => {
    setExpanded(expanded2);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Accordion,
    {
      className,
      expanded,
      onChange: handleExpand,
      slotProps: {
        transition: { unmountOnExit: unmountOnCollapse }
      }
    },
    /* @__PURE__ */ React.createElement(AccordionSummary, { id: componentId, expandIcon: /* @__PURE__ */ React.createElement(ExpandMore, null), "aria-controls": `${componentId}-content` }, /* @__PURE__ */ React.createElement(Typography, { variant: "h6", className: classes.accordionHeader }, header ? React.isValidElement(header) ? header : /* @__PURE__ */ React.createElement(LocalizedText, { label: header }) : null)),
    /* @__PURE__ */ React.createElement(AccordionDetails, { className: classes.accordionDetails }, children)
  ));
};
export {
  StyledAccordion as default
};
//# sourceMappingURL=StyledAccordion.js.map
